<template>
  <b-row>
    <b-col cols="12">
      <b-row>
        <b-col>
          <div style="display:flex;justify-content: center;">
            <h4
              style=" display:flex;"
            >
              Contratos em tramitações
              <div style="padding-left: 0.4rem">
                <i
                  v-b-tooltip.hover
                  :title="'Contratos em tramitação de assinatura, com pendência de ação por parte do Cliente (Aguardando envio de dados) ou da equipe interna (Em análise). As propostas em Aguardando assinatura não são incluídas na somatória dos totalizadores.'"
                  style="font-size: 0.85rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </h4></div>
        </b-col>
      </b-row>
      <b-row
        align-h="between"
        style="flex-direction: column;
        margin-left: 0px;"
      >
        <div
          style="    display: flex;
                     align-items: center;"
        >
          <div
            :style="`background-color: #DFC927`"
            :class="['square', {'opcao-branca': '#DFC927' === '#FFFFFF'}]"
          />
          <div>Aguardando envio de dados</div>
        </div>

        <div
          style="    display: flex;
                      align-items: center;"
        >
          <div
            :style="`background-color: #FF8400`"
            :class="['square', {'opcao-branca': '#FF8400' === '#FFFFFF'}]"
          />
          <div>
            Em análise
          </div>
        </div>

        <div
          style="    display: flex;
                      align-items: center;"
        >
          <div
            :style="`background-color: #0079BF`"
            :class="['square', {'opcao-branca': '#0079BF' === '#FFFFFF'}]"
          />
          <div>
            Aguardando assinatura
          </div>
        </div>

      </b-row>
      <b-row
        align-h="center"
      >
        <donut-chart-comercial
          :id="$index"
          :dados="totalContratos"
          :total="totalContratos.totalPropostaStatus"
          :height="290"
        />
      </b-row>
      <b-col
        cols="auto"
        style="display: flex;align-items: center; border-top: 0.80px solid #82868b;justify-content:space-evenly;"
      >
        <div>
          <div
            style="display:flex;
               justify-content:center;
               align-items: center;"
          >
            <div
              :style="`background-color: #DFC927`"
              :class="['square', {'opcao-branca': '#DFC927' === '#FFFFFF'}]"
            />
            <div
              style="text-align: center;
               font-size: 16px;"
            >
              <b>

                Ação com Cliente
              </b>
            </div>
          </div>
          <div class="textogrande">
            <b>{{ totalContratos.quantidade[2] }}</b>
          </div>
        </div>

        <div style="border-left: 0.80px solid #82868b; height: 50px;">
        &nbsp;
        </div>

        <div>
          <div
            style="display:flex;
               justify-content:center;
               align-items: center;"
          >
            <div
              style="background-color: #FF8400;"
              :class="['square', {'opcao-branca': '#FF8400' === '#FFFFFF'}]"
            />
            <div
              style="align-self: center;
                font-size: 16px;"
            >
              <b>
                Ação Interna
              </b>
            </div>
          </div>
          <div class="textogrande">
            <b>{{ totalContratos.quantidade[1] }}</b>
          </div>
        </div>
      </b-col>
    </b-col>
  </b-row>
</template>

  <style lang="scss">

  .textogrande{
    margin-left: 65px;
    font-weight: bold;
    font-size: 22px;
  }
  .square {
    height: 10px;
    width: 10px;
    margin-right: 0.5rem;

  }
  .opcao-branca{
    border: 1px solid #82868b !important;
  }
  </style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/comercial/dashboard-comercial/shared/services/api'

export default {
  name: 'DetalhamentoContrato',
  components: {
    FontAwesomeIcon,
    DonutChartComercial: () => import('@/shared/components/donutchart-comercial/DonutChartComercial.vue'),
  },
  data() {
    return {
      faQuestionCircle,
      carregado: false,
      totalContratos: [],
      checklistTotal: null,
    }
  },
  created() {
    this.carregaDados()
  },
  methods: {
    carregaDados() {
      api.getTotalContratos()
        .then(payload => {
          this.totalContratos = payload.data
          this.checklistTotal = payload.data.totalDePropostas
          this.carregado = true
        })
    },
  },
}
</script>
